import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AboutPage from "../pages/about/page";
import FAQPage from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hakkimizda",
    element: <AboutPage />,
  },
  {
    path: "/sss",
    element: <FAQPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
